export default __webpack_public_path__ + "static/media/element_22.1c244eb9.jpg";